<div [@globalRouterTransition]="animationData()" class="mat-typography">
    <mat-spinner class="main-load-element" *ngIf="loading"></mat-spinner>
    <router-outlet></router-outlet>
</div>
